export const TARGET_CLS = 'ant-wave-target';


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/_util/wave/interface.js
// module id = 413
// module chunks = 0